import { components } from 'be-types';
import { DataScope } from './global-enum';
import { ApiRequestParams } from './global-interfaces';

export const locationOrderApiRequestParams: ApiRequestParams = {
  dataScope: DataScope.LocationTable,
};

export type CreateLocationRequest = components['schemas']['CreateLocationRequest'];
export type TaskBoardUserResource = components['schemas']['User'];
